export default __webpack_public_path__ + "static/media/smtp-hover.1de110fc.svg";